/* ============================================================================
   NEOGEN — FOOTER newsletter capture (LIVE Klaviyo subscribe)
   ----------------------------------------------------------------------------
   Landed 2026-07-07 as an honest stub (Sonnet 5 Liquid sprint, Phase 0).
   WIRED LIVE 2026-08-13: Klaviyo client-API subscription (Craig decision,
   "split by source"):
     • NOW (pre-launch): all signups → Early Access / Waitlist (RjgJ63),
       single opt-in — no confirm-email friction.
     • AT LAUNCH: switch LIST_ID to NEOGEN Inner Circle (Newsletter) VJ6wmT
       (double opt-in) — one-line change below, marked LAUNCH-SWITCH.

   Pairs with snippets/neogen-footer.liquid `.footer__form[data-klaviyo-source]`.
   Contract (interaction-contracts.md §10): reused across footer /
   prelaunch-apex / bench-notes-comingsoon via [data-klaviyo-source].
   Attribution: the hidden "source" input (specific placement, e.g. hp-footer)
   is sent as custom_source; falls back to data-klaviyo-source (placement
   family) if the hidden field is absent.

   NOTE: the prelaunch holding page uses a native Shopify {% form 'customer' %}
   and is NOT handled here — it reaches Klaviyo via the Shopify integration's
   subscriber sync (Klaviyo → Integrations → Shopify), target list Waitlist.
   ============================================================================ */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'TQs8tE';
  // LAUNCH-SWITCH: change to 'VJ6wmT' (Inner Circle / Newsletter) at launch.
  var LIST_ID = 'RjgJ63'; // Early Access / Waitlist (single opt-in)
  var ENDPOINT =
    'https://a.klaviyo.com/client/subscriptions/?company_id=' +
    KLAVIYO_COMPANY_ID;

  var forms = document.querySelectorAll('.footer__form[data-klaviyo-source]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var status = form.querySelector('.footer__form-status');
      var button = form.querySelector('button[type="submit"], button:not([type])');
      if (!input || !status) return;

      if (!input.validity.valid) {
        status.textContent = 'Please enter a valid email address.';
        return;
      }

      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      if (button) button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = '';

      var sourceField = form.querySelector('input[name="source"]');
      var customSource =
        (sourceField && sourceField.value) || form.dataset.klaviyoSource || 'site';

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: customSource,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: input.value.trim() }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: LIST_ID } }
          }
        }
      };

      fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2024-10-15'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok) {
            // 202 Accepted, empty body — true success from the API.
            status.textContent = 'You’re on the list.';
            input.value = '';
          } else {
            status.textContent =
              'Something went wrong — please try again in a moment.';
          }
        })
        .catch(function () {
          status.textContent =
            'Something went wrong — please try again in a moment.';
        })
        .finally(function () {
          form.dataset.submitting = 'false';
          if (button) button.disabled = false;
          form.removeAttribute('aria-busy');
        });
    });
  });
})();
